<script setup>
import FormularioVerificacionTarjeta from '../../components/formularioVerificacionTarjeta.vue';
</script>
<template>
    <FormularioVerificacionTarjeta urlSiguiente="/cliente/verificar-correo" :nombreEditable="false"/>
</template>